export default {"src":"/_next/static/media/cryptopedia_social_facebook.c161a6a1.svg","height":23,"width":23,"blurWidth":0,"blurHeight":0};